var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkModePlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0C10.6904 0 11.25 0.559644 11.25 1.25V8.75H18.75C19.4404 8.75 20 9.30964 20 10C20 10.6904 19.4404 11.25 18.75 11.25H11.25V18.75C11.25 19.4404 10.6904 20 10 20C9.30964 20 8.75 19.4404 8.75 18.75V11.25H1.25C0.559644 11.25 0 10.6904 0 10C0 9.30964 0.559644 8.75 1.25 8.75H8.75V1.25C8.75 0.559644 9.30964 0 10 0Z",
    fill: "#191C1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkModePlusIcon);
export default __webpack_public_path__ + "static/media/Dark_Mode_Plus_Icon.24a57f82f3455928457a9fa73cf29e25.svg";
export { ForwardRef as ReactComponent };